module.exports = __webpack_public_path__ + "img/fahrradgarage_varianten.7b9ef313.jpg";